import createApiService from '../../http';
import { FETCH_DISEASES, FETCH_AFRICA_SUMMARY, FETCH_COUNTRIES_DATA } from './endpoints';

export const fetchDiseaseService = (params) =>
  createApiService({
    endpoint: FETCH_DISEASES,
    method: "get",
    options: {
      params: {
        ...params,
      },
    },
  });


export const fetchAfricaSummaryService = createApiService({
  endpoint: FETCH_AFRICA_SUMMARY,
  method: 'get'
});

export const fetchCountryDataService = createApiService({
method: 'get',
endpoint: FETCH_COUNTRIES_DATA
});